export default __webpack_public_path__ + "static/media/Servisor_logo.5b35bd33.svg";